!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], n) : n(e.useDoubleTap = {}, e.react);
}(this, function (e, n) {
  e.useDoubleTap = function (e, t, u) {
    void 0 === t && (t = 300), void 0 === u && (u = {});
    var o = n.useRef(null),
        r = n.useCallback(function (n) {
      o.current ? (clearTimeout(o.current), o.current = null, e && e(n)) : o.current = setTimeout(function () {
        u.onSingleTap && u.onSingleTap(n), o.current = null;
      }, t);
    }, [e, t, u.onSingleTap]);
    return e ? {
      onClick: r
    } : {};
  };
});